import { render } from "./DashboardBoxSearch.vue?vue&type=template&id=69cc94f0&scoped=true"
import script from "./DashboardBoxSearch.vue?vue&type=script&lang=js"
export * from "./DashboardBoxSearch.vue?vue&type=script&lang=js"

import "./DashboardBoxSearch.vue?vue&type=style&index=0&id=69cc94f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cc94f0"]])

export default __exports__